import React, { useEffect, useState } from "react";
import { Input, Select, Empty, Spin, Tag, Pagination } from "antd";

import JdEventCard from "../JdEventCard";
import "./JdEventsPage.scss";
import useJDStore from "../../store/jd.store";
import Filter from "../filter";
import { useLocation, useNavigate } from "react-router-dom";

const JdEventsPage = () => {
   const location = useLocation();
   const navigate = useNavigate();
   const pathSegments = location.pathname.split("/");
   const parentPath = pathSegments[1];    

    // Use your actual Zustand store
    const {
        jdEventsData,
        allJDsEventCount,
        getAllJDsEventPagination,
        jdEventsStats
    } = useJDStore();


    useEffect(() => {
    }, []);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    }; 
    const getEventStatus = (event) => {
        // Use your existing status calculation logic
        return event.eventstatus || "UPCOMING";
    };



    const handleViewEvent = (event) => {
        console.log("View event:", event);
        navigate(`/jds/${event.qhcompanyjid}`);
    };

    const handleEditEvent = (event) => {
        console.log("Edit event:", event);
    };

    return (
        <div className="jd-events-page">

            <div className="jd-events-header">
                <div>
                    <h2>Hiring Events</h2>
                    <p>Manage and track your hiring events</p>
                </div>

                <Tag color="blue">
                    Total Events: {allJDsEventCount || 0}
                </Tag>
            </div>
      <div>
      <Filter
        filtername = {"getAllJDsEventPagination"}
        initDuration={"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"} 
        initClient={"All"}
        pageNo = {currentPage}
        pageSize ={pageSize}  
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs     
        handleFilter={getAllJDsEventPagination}
        pageHandler = {setCurrentPage}  
      />
      <div></div>
      </div>
            {jdEventsData?.length === 0 ? (
                    <Empty description="No hiring events found" />
            ) : (
                <div className="jd-events-grid">
                        {jdEventsData?.map((event,idx) => (
                            <JdEventCard
                                key={event.qheventid}
                                event={event}
                                status={getEventStatus(event)}
                                onView={handleViewEvent}
                                onEdit={handleEditEvent}
                                stats = {jdEventsStats?.[idx]}
                            />
                        ))}
                </div>
            )}
       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={allJDsEventCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />             
        </div>
    );
};

export default JdEventsPage;